import React from "react";
import { useTranslation } from "react-i18next";
import Routes from "routing/Routes";
import { ReplaySearchButtonComponent } from "views/components/widgets/ReplaySearchButton";
import usePermissions from "hooks/usePermissions";
import MenuItem from "components/bootstrap/menuitem/MenuItem";
const EventReplaySearchLink = ({ eventId, eventDefinitionId, onClick = void 0, isMenuitem = false }) => {
  const { t } = useTranslation("events");
  const { isPermitted } = usePermissions();
  if (!isPermitted(`eventdefinitions:read:${eventDefinitionId}`)) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    ReplaySearchButtonComponent,
    {
      searchLink: Routes.ALERTS.replay_search(eventId),
      onClick,
      component: isMenuitem ? MenuItem : void 0
    },
    t("alerts_list.replay_search")
  );
};
export default EventReplaySearchLink;
